import type { DataOption } from '@/common.types'

import { useTranslation } from 'react-i18next'

import { RHFSelect } from '@/shared/components/HookForm'
import { getLangCode, useLocale } from '@/shared/i18n'

import { useTicketTypesQuery } from '../api/queries'
import { TICKET_COMMON_TYPES, TICKET_SPECIFIC_TYPES } from '../lib/constants'

export function TicketTypeField() {
	const { t } = useTranslation()
	const currentLocale = useLocale()
	const { data: ticketTypes, isLoading } = useTicketTypesQuery(
		{
			lang_code: getLangCode(currentLocale),
		},
		{
			select: (data): DataOption[] =>
				data?.map(
					(item: { id: string; name: string }) =>
						({
							value: item.id,
							label: item.name,
						}) as DataOption
				) || [],
		}
	)

	return (
		<RHFSelect
			isLoading={isLoading}
			options={[
				{
					label: t('jsd.requesttype.category.specific', {
						defaultValue: 'Specific types',
					}),
					options: (ticketTypes ?? []).filter((item) =>
						TICKET_SPECIFIC_TYPES.includes(item.value)
					),
				},
				{
					label: t('jsd.requesttype.category.common', {
						defaultValue: 'Common types',
					}),
					options: (ticketTypes ?? []).filter((item) =>
						TICKET_COMMON_TYPES.includes(item.value)
					),
				},
			]}
			className='w-full'
			placeholder={t('app.select_category', {
				defaultValue: 'Select category',
			})}
			label={t('support.window.form.category.label', {
				defaultValue: 'I’m writing about...',
			})}
			name='requesttype'
		/>
	)
}
